import girl_in_ice from './img/girl_in.jpg'
import it_starts_with_us from './img/it_starts_with_us.jpg'
import like_A_sisiter from './img/like_A_sisiter.jpg'
import little_women from './img/little_women.jpg'
import night_shift from './img/night_shift.jpg'
import lolita from './img/lolita.jpg'
import our_american_friend from './img/our_american_friend.jpg'
import pay_dirt_road from './img/pay_dirt_road.jpg'
import olga_dies from './img/olga_dies.jpg'
import book_of_night from './img/book_of_night.jpg'
import brave_new_world from './img/brave_new_world.jpg'
import fahrenheit from './img/fahrenheit.jpg'
import run_rose_run from './img/run_rose_run.jpg'
import the_book_thief from './img/the_book_thief.jpg'
import the_fields from './img/the_fields.jpg'
import the_golden_couple from './img/the_golden_couple.jpg'
import the_great_gatsby from './img/the_great_gatsby.jpg'
import the_girl_with_the_dragon from './img/the_girl_with_the_dragon.jpg'
import the_magnolia_palace from './img/the_magnolia_palace.jpg'
import where_the_crawdads from './img/where_the_crawdads.jpg'
import to_paradise from './img/to_paradise.jpg'
import trust from './img/trust.jpg'
import violeta from './img/violeta.jpg'
import what_happened from './img/what_happened.jpg'

export const FBookItems = [
  {
    id:201,
    title:"girl_in_ice",
    image: girl_in_ice,
    price:1000,
    
  },
  {
    id:202,
    title:"The Da Vinci Code",
    image: it_starts_with_us,
    price:100,
    
  },
  {
    id:203,
    title:"The Da Vinci Code",
    image: like_A_sisiter,
    price:100,
    
  },
  {
    id:204,
    title:"The Da Vinci Code",
    image: little_women,
    price:100,
    
  },
  {
    id:205,
    title:"The Da Vinci Code",
    image: night_shift ,
    price:100,
    
  },
  {
    id:206,
    title:"The Da Vinci Code",
    image: lolita,
    price:100,
    
  },
  {
    id:207,
    title:"The Da Vinci Code",
    image: our_american_friend,
    price:100,
    
  },
  {
    id:208,
    title:"The Da Vinci Code",
    image: pay_dirt_road,
    price:100,
    
  },
  {
    id:209,
    title:"The Da Vinci Code",
    image: olga_dies,
    price:100,
    
  },
  {
    id:210,
    title:"The Da Vinci Code",
    image: book_of_night,
    price:100,
    
  },
  {
    id:211,
    title:"The Da Vinci Code",
    image:brave_new_world,
    price:100,
    
  },
  {
    id:212,
    title:"The Da Vinci Code",
    image: fahrenheit,
    price:100,
    
  },
  {
    id:213,
    price:100,
    title: "Gone Girl",
    image: run_rose_run,
    
  },
  {
    id:214,
    price:100,
    title: "My Sister The Serial Killer",
    image: the_book_thief,
   
  },
  {id:215,
    price:100,
    title: "Before I Go To Sleep",
    image:  the_fields,
    
  },
  {
    id:216,
    price:100,
    title: "The Girl On The Train",
    image: the_golden_couple,
    
  },
  {
    id:217,
    price:100,
    title: "Then She Was Gone",
    image: the_great_gatsby,
    
  },
  {
    id:218,
    price:100,
    title: "The Girl Who Kicked The Hornet Nest",
    image: the_girl_with_the_dragon,
    
  },
  {
    id:219,
    price:100,
    title: "The Lost Symbol",
    image: the_magnolia_palace,
    
  },
  {
    id:220,
    price:100,
    title: "The Girl With The Dragon Tattoo",
    image: where_the_crawdads,
    
  },
  {
    id:221,
    price:100,
    title: "The Girl With The Dragon Tattoo",
    image: to_paradise ,
    
  },
  {
    id:222,
    price:100,
    title: "The Girl With The Dragon Tattoo",
    image: trust,
    
  },
  {
    id:223,
    price:100,
    title: "The Girl With The Dragon Tattoo",
    image: violeta,
    
  },
  {
    id:224,
    price:100,
    title: "The Girl With The Dragon Tattoo",
    image: what_happened ,
    
  },
  
];